define('PDPAssemblyItem.View',
  [	'js.cookie',
    'unlockcommerce_pdpassemblyitem_pdpassemblyitem.tpl',
    'pdpassemblyitem_side_panel.tpl',
    'Backbone'
  ], function (
    Cookies,
    TemplateBottom,
    TemplateSide,
    Backbone
  ) {
    'use strict';

    return Backbone.View.extend({
      template: TemplateBottom,

      initialize: function initialize(options) {
        var itemInfo = options.pdp.getItemInfo();
        this.internalid = itemInfo.item.internalid;
        this.externalid = itemInfo.item.externalid;
        this.isControl = true;
        if (itemInfo.item.commercecategory && itemInfo.item.commercecategory.primarypath) {
          var isControl = itemInfo.item.commercecategory.primarypath.find(function (categ) {
            return categ.name.toLowerCase().indexOf('controls') > -1;
          });
          this.isControl = isControl;
        } else {
          this.isControl = false;
        }
        this.sessionId = Cookies.get('NLVisitorId');
        this.customerId = options.profile.isloggedin ? options.profile.internalid : '0';
        this.template = options.position === 'side' ? TemplateSide : TemplateBottom;
        this.sideFrame = options.position === 'side' && itemInfo.item.custitem_uc_side_iframe;
      },

      events: {
        'click [data-action="toggle-collapse"]': 'toggleCollapseIframe'
      },

      toggleCollapseIframe: function toggleCollapseIframe(element) {
        var clickedTitle = element.currentTarget;
        var panel = jQuery(clickedTitle).next('.collapsible');
        var title = jQuery('#product-details-information-collapsible');

        if (panel.length) {
          var isOpen = panel.hasClass('open');

          if (isOpen) {
            panel.removeClass('open');
            title.removeClass('open');
          } else {
            panel.addClass('open');
            title.addClass('open');
          }
        }
      },

      getContext: function getContext() {
        return {
          sideFrame: this.sideFrame,
          sessionId: this.sessionId,
          isControl: this.isControl,
          customerId: this.customerId,
          externalid: this.externalid,
          internalid: this.internalid
        };

      }
    });
  });
